var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "155.000000pt",
    height: "325.000000pt",
    viewBox: "0 0 155.000000 325.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,325.000000) scale(0.100000,-0.100000)",
    fill: "#f00",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590 3235 c-113 -31 -210 -124 -251 -239 -18 -53 -19 -90 -19 -894 l0 -839 -58 -45 c-104 -81 -185 -199 -229 -333 -21 -65 -26 -101 -26 -190 -2 -133 11 -192 70 -314 77 -161 222 -287 402 -348 107 -37 281 -39 391 -4 121 37 206 87 290 171 136 137 191 262 198 455 5 143 -9 211 -68 330 -45 92 -108 172 -177 227 l-48 37 -5 858 -5 858 -32 67 c-77 164 -261 250 -433 203z m207 -137 c48 -22 98 -74 122 -127 14 -32 16 -130 19 -931 l3 -895 44 -28 c132 -84 225 -262 225 -432 0 -144 -50 -265 -155 -371 -106 -108 -223 -158 -370 -157 -238 1 -442 154 -509 382 -23 78 -21 222 4 303 34 112 140 246 228 292 l32 16 2 898 3 897 22 40 c67 125 204 172 330 113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 2896 c-17 -8 -36 -23 -42 -35 -8 -14 -11 -293 -11 -913 l0 -893 -58 -25 c-73 -31 -154 -112 -190 -187 -24 -51 -27 -70 -27 -158 0 -88 3 -107 27 -157 37 -80 107 -152 187 -191 61 -30 73 -32 166 -32 87 0 107 3 156 26 197 93 280 320 189 517 -36 78 -109 151 -184 183 l-56 24 0 882 c0 536 -4 892 -10 907 -19 50 -92 76 -147 52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 2705 l0 -55 155 0 c142 0 157 2 175 20 24 24 25 38 4 68 -15 21 -21 22 -175 22 l-159 0 0 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 2395 l0 -55 160 0 160 0 17 26 c15 24 15 29 2 53 l-15 26 -162 3 -162 2 0 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 2085 l0 -55 159 0 c154 0 160 1 175 22 21 30 20 44 -4 68 -18 18 -33 20 -175 20 l-155 0 0 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 1770 l0 -60 145 0 c155 0 190 8 199 45 16 63 -15 75 -200 75 l-144 0 0 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 1455 l0 -55 155 0 c142 0 157 2 175 20 24 24 25 38 4 68 -15 21 -21 22 -175 22 l-159 0 0 -55z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.ecb5c34ba897a560794be5b8b0de90cc.svg";
export { ForwardRef as ReactComponent };